import Swiper from 'swiper';

export default {
  init() {
    new Swiper ('.home-hero-slider__container', {
      effect: 'fade',
      slidesPerView: 1,
      speed: 600,
      spaceBetween: 30,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
    });
  }
}
